import { getToken } from "../../common/environment_config.es6";
import { apiPost } from "../../common/http_service";

export async function syncScene(
  trainingId,
  navId,
  pluginToolbarsById,
  boxesById,
  audioDuration,
  sceneSounds
) {
  const url = `${window.ideaLibraryRootUrl || ""}api/studio/sync-scene`;
  const body = { trainingId, navId, pluginToolbarsById, boxesById };
  // The scene's narration clips exactly as the timeline draws them — the
  // backend ends every element with the last one. A scene can hold two
  // speakers, start at something other than zero, or hide a take, so the list
  // goes over as a list; `audioDuration` below cannot express any of that.
  if (Array.isArray(sceneSounds) && sceneSounds.length > 0) {
    body.sceneSounds = sceneSounds.map((s) => ({
      startTime: s.startTime,
      endTime: s.endTime,
      duration: s.duration,
      visible: s.visible,
      loopScene: s.loopScene,
    }));
  }
  // Legacy single value, kept so this still works against a backend deployed
  // before sceneSounds landed.
  if (typeof audioDuration === "number" && audioDuration > 0) {
    body.audioDuration = audioDuration;
  }

  try {
    const token = getToken();
    const xsrfToken = window.getAuthToken ? window.getAuthToken() : "";

    const response = await apiPost(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error(`Sync failed: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
}
